import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CategoryIcon from '@mui/icons-material/Category';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventIcon from '@mui/icons-material/Event';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ImageIcon from '@mui/icons-material/Image';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NotesIcon from '@mui/icons-material/Notes';
import NumbersIcon from '@mui/icons-material/Numbers';
import PaymentsIcon from '@mui/icons-material/Payments';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import ShortTextIcon from '@mui/icons-material/ShortText';
import StarsIcon from '@mui/icons-material/Stars';
import StraightenIcon from '@mui/icons-material/Straighten';
import TitleIcon from '@mui/icons-material/Title';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import type { FieldType } from '@re/form-engine';
import type { SvgIconProps } from '@mui/material';
import type { ComponentType } from 'react';
import { tr } from '../../lib/i18n';

export const FIELD_META: Record<FieldType, { icon: ComponentType<SvgIconProps>; hint: string }> = {
  request_type: { icon: CompareArrowsIcon, hint: tr('بيع، تأجير، شراء… يحدد وجهة الإدخال', 'Sale, rent, buy… sets where the entry goes') },
  property_category: { icon: CategoryIcon, hint: tr('سكني، تجاري، أراضي…', 'Residential, commercial, land…') },
  property_type: { icon: HomeWorkIcon, hint: tr('يُفلتر تلقائياً حسب الفئة', 'Filtered automatically by category') },
  property_features: { icon: StarsIcon, hint: tr('اختيار متعدد، يُفلتر حسب نوع العقار', 'Multi-select, filtered by property type') },
  location: { icon: PlaceIcon, hint: tr('دولة ← محافظة ← منطقة ← حي', 'Country → governorate → area → neighborhood') },
  map_point: { icon: SatelliteAltIcon, hint: tr('رابط خرائط Google أو موقعي الحالي أو تحديد على الخريطة', 'Google Maps link, my location or a pin on the map') },
  text: { icon: ShortTextIcon, hint: tr('سطر واحد', 'Single line') },
  textarea: { icon: NotesIcon, hint: tr('عدة أسطر', 'Multiple lines') },
  number: { icon: NumbersIcon, hint: tr('رقم مع حد أدنى وأعلى', 'Number with min and max') },
  number_range: { icon: StraightenIcon, hint: tr('من – إلى (مساحة، ميزانية)', 'From – to (area, budget)') },
  currency: { icon: PaymentsIcon, hint: tr('مبلغ بعملة الدولة', 'Amount in the country\'s currency') },
  phone: { icon: PhoneIcon, hint: tr('يُحوَّل لصيغة دولية', 'Converted to international format') },
  email: { icon: AlternateEmailIcon, hint: tr('بريد إلكتروني', 'Email address') },
  date: { icon: EventIcon, hint: tr('تاريخ واحد', 'Single date') },
  date_range: { icon: DateRangeIcon, hint: tr('من تاريخ – إلى تاريخ', 'From date – to date') },
  boolean: { icon: ToggleOnIcon, hint: tr('نعم / لا', 'Yes / No') },
  radio: { icon: RadioButtonCheckedIcon, hint: tr('خيار واحد كأزرار', 'Single choice as buttons') },
  dropdown: { icon: ArrowDropDownCircleIcon, hint: tr('خيار واحد من قائمة', 'Single choice from a list') },
  checkbox_group: { icon: CheckBoxIcon, hint: tr('عدة خيارات', 'Multiple choices') },
  image_upload: { icon: ImageIcon, hint: tr('صور العقار', 'Property photos') },
  file_upload: { icon: AttachFileIcon, hint: tr('ملفات PDF', 'PDF files') },
  section: { icon: TitleIcon, hint: tr('عنوان يفصل الأقسام', 'Heading that separates sections') },
  info: { icon: InfoOutlinedIcon, hint: tr('نص إرشادي للعميل', 'Guidance text for the customer') },
};

export function FieldIcon({ type, ...p }: { type: FieldType } & SvgIconProps) {
  const I = FIELD_META[type].icon;
  return <I {...p} />;
}
